import axios from "axios";
import { isTokenExpired, refreshAccessToken } from "./TokenService";

// Manager endpoints on the API are protected, but many screens call them with plain axios and no
// Authorization header. Attaching the current token here covers every call to our API in one place
// (and refreshes an expired token first), so a protected endpoint never fails just because a caller
// forgot to send it. Public pages are unaffected: with no stored token nothing is added.
let refreshing: Promise<unknown> | null = null;

const apiUrl = process.env.REACT_APP_API_URL;

export const installAuthInterceptor = () => {
  (axios as any).interceptors.request.use(async (config: any) => {
    const url = `${config.baseURL ?? ""}${config.url ?? ""}`;
    if (!apiUrl || !url.startsWith(apiUrl) || url.includes("/Auth/")) {
      return config;
    }

    let token = localStorage.getItem("accessToken");
    if (!token) {
      return config;
    }

    if (isTokenExpired(token) && localStorage.getItem("refreshToken")) {
      if (!refreshing) {
        refreshing = refreshAccessToken().finally(() => {
          refreshing = null;
        });
      }
      await refreshing;
      token = localStorage.getItem("accessToken") ?? token;
    }

    config.headers = config.headers ?? {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
};
